import { render, staticRenderFns } from "./PacketPayBox.vue?vue&type=template&id=056b107e&scoped=true"
import script from "./PacketPayBox.vue?vue&type=script&lang=js"
export * from "./PacketPayBox.vue?vue&type=script&lang=js"
import style0 from "./PacketPayBox.vue?vue&type=style&index=0&id=056b107e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056b107e",
  null
  
)

export default component.exports